export const TEMPLATES_API = '/api/templates/funnels'
